export const generateSortedArray = (size: number, maxVal: number): number [] => {
  const arr: number[] = [];
  for (let i = 0; i < size; i++){
    arr.push(Math.floor(Math.random() * maxVal) + 1);
  }
  return arr.sort((a,b) => a-b);
};

export const generateUnsortedArray = (size: number, maxVal: number): number []  => {
  const arr: number[] = []
  for(let i = 0; i < size; i++){
    arr.push(Math.floor(Math.random() * maxVal) + 1);
  }
  return arr;
}